<template>
  <div>
    <h1>Cónclave</h1>
    <p>
      Hay {{ electors.length }} cardenales electores. Son los que eligen al
      papa. Aunque podría no ser así, lo normal es que voten a uno de ellos.
    </p>

    <!-- spotlight-->
    <div style="margin-bottom: 10px; margin-top: 10px">
      <button @click="autoPick()">Aleatorio</button>
      <div v-if="randomItem">
        <div
          class="person-card"
          style="
            width: 100%;
            max-width: 500px;
            position: relative;
            margin: auto;
            margin-top: 20px;
            margin-bottom: 40px;
          "
        >
          <div
            v-if="bookmarks.includes(randomItem.rank)"
            style="position: absolute; top: 4px; right: 4px"
          >
            ⭐
            <!-- 📌 -->
          </div>
          <img
            :src="randomItem.image_url"
            :alt="randomItem.name"
            style="height: 350px"
            @click="toogleBookmark(randomItem.rank)"
          />
          <a :href="randomItem.wiki" target="_blank" class="no-link">
            <h3>{{ randomItem.name }}</h3>
            <div class="country">{{ randomItem.pais }}</div>
          </a>
        </div>
      </div>
    </div>
    <!-- filters -->
    <div>
      <!-- bookmarks -->
      <div>
        <div>
          <span :style="{ bold: !onlyBookmarks }" @click="onlyBookmarks = false"
            >Todos ({{ electors.length }})</span
          >
          /
          <span :style="{ bold: onlyBookmarks }" @click="onlyBookmarks = true"
            >Favoritos ({{ bookmarks.length }})</span
          >
        </div>
      </div>
      <!-- continents -->
      <div style="display: flex; flex-wrap: wrap; margin-bottom: 8px">
        <div
          v-for="(v, k) in continents2"
          class="chip"
          :key="k"
          @click="toggleContinent(k)"
        >
          {{ k || "Unknownn" }} ({{ v }})
        </div>
      </div>

      <!-- countries -->
      <div style="display: flex; flex-wrap: wrap">
        <div
          v-for="(c, i) in countries"
          class="chip"
          :key="i"
          @click="toggleCountry(c)"
        >
          {{ c }} ({{ countries2[c] }})
        </div>
      </div>
    </div>
    <!-- electors -->
    <div class="people-container">
      <div
        v-for="(elector, index) in filteredList"
        :key="index"
        class="person-card"
        style="position: relative"
      >
        <div
          v-if="bookmarks.includes(elector.rank)"
          style="position: absolute; top: 4px; right: 4px"
        >
          ⭐
          <!-- 📌 -->
        </div>
        <img
          width="100"
          :src="elector.image_url"
          :alt="elector.name"
          @click="toogleBookmark(elector.rank)"
        />
        <a :href="elector.wiki" target="_blank" class="no-link">
          <h3>{{ elector.name }}</h3>
          <div class="country">{{ elector.country }}</div>
        </a>
      </div>
    </div>

    <div style="height: 60px"></div>
  </div>
  <!-- 
  <PersonView msg="Welcome to Your Vue.js App" />
  -->
</template>

<script>
//import PersonView from "./components/PersonView.vue";

export default {
  name: "App",
  components: {
    //PersonView,
  },
  computed: {
    continents2() {
      let x = {};
      for (let i = 0; i < this.electors.length; i++) {
        const e = this.electors[i];
        const c = e.continent || "Unknown";
        if (!x[c]) x[c] = 0;
        x[c]++;
      }
      return x;
    },
    continents() {
      const c = this.electors.map((x) => x.continent);
      const s = new Set(c);
      return [...s];
    },

    countries2() {
      let x = {};
      for (let i = 0; i < this.electors.length; i++) {
        const e = this.electors[i];
        const c = e.country;
        if (!x[c]) x[c] = 0;
        x[c]++;
      }
      return x;
    },
    countries() {
      if (!this.continent) return [];
      const c1 = this.electors.filter((x) => x.continent == this.continent);
      const c = c1.map((x) => x.country);
      const s = new Set(c);
      return [...s];
    },
    filteredList() {
      const f1 = this.electors.filter((x) => x.continent == this.continent);
      const f2 = f1.filter((x) => x.country == this.country || !this.country);

      if (this.onlyBookmarks) {
        const f3 = f2.filter((x) => this.bookmarks.includes(x.rank));
        return f3;
      } else {
        return f2;
      }
    },
  },

  data() {
    return {
      randomItem: null,
      onlyBookmarks: false,
      bookmarks: [],
      continent: null,
      country: null,
      electors: [
        {
          rank: 6,
          name: "Pietro Parolin",
          wiki: "https://en.wikipedia.org/wiki/Pietro_Parolin",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Cardinal_Pietro_Parolin_par_Claude_Truong-Ngoc_juillet_2021.jpg/500px-Cardinal_Pietro_Parolin_par_Claude_Truong-Ngoc_juillet_2021.jpg",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 8,
          name: "Fernando Filoni",
          wiki: "https://en.wikipedia.org/wiki/Fernando_Filoni",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/68/Card._Fernando_Filoni_in_Taiwan.jpg/500px-Card._Fernando_Filoni_in_Taiwan.jpg",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 10,
          name: "Luis Antonio Tagle",
          wiki: "https://en.wikipedia.org/wiki/Luis_Antonio_Tagle",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Luis_Antonio_Tagle_at_Manila_in_2016_%28cropped%29.jpg/500px-Luis_Antonio_Tagle_at_Manila_in_2016_%28cropped%29.jpg",
          country: "Philippines",
          continent: "Asia",
          pais: "Filipinas",
        },
        {
          rank: 11,
          name: "Robert Francis Prevost",
          wiki: "https://en.wikipedia.org/wiki/Robert_Francis_Prevost",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/7/7d/Mons._Robert_Prevost%2C_OSA_%28cropped%29.jpg",
          country: "United States",
          continent: "Am\u00E9rica del Norte",
          pais: "Estados Unidos",
        },
        {
          rank: 13,
          name: "Louis Rapha\u00EBl I Sako",
          wiki: "https://en.wikipedia.org/wiki/Louis_Rapha%C3%ABl_I_Sako",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Louis_Rapha%C3%ABl_I_Sako_November_2015.jpg/500px-Louis_Rapha%C3%ABl_I_Sako_November_2015.jpg",
          country: "Iraq",
          continent: "Asia",
          pais: "Irak",
        },
        {
          rank: 23,
          name: "Vinko Pulji\u0107",
          wiki: "https://en.wikipedia.org/wiki/Vinko_Pulji%C4%87",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Vinko_Puljic_June_2015_%2818760757238%29.jpg/500px-Vinko_Puljic_June_2015_%2818760757238%29.jpg",
          country: "Bosnia and Herzegovina",
          continent: "Europa",
          pais: "Bosnia y Herzegovina",
        },
        {
          rank: 45,
          name: "Peter Turkson",
          wiki: "https://en.wikipedia.org/wiki/Peter_Turkson",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Peter_Turkson_%28cropped%29.jpg/500px-Peter_Turkson_%28cropped%29.jpg",
          country: "Ghana",
          continent: "\u00C1frica",
          pais: "Ghana",
        },
        {
          rank: 46,
          name: "Josip Bozani\u0107",
          wiki: "https://en.wikipedia.org/wiki/Josip_Bozani%C4%87",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/6/61/CardinalJosipBozani%C4%87.jpg",
          country: "Croatia",
          continent: "Europa",
          pais: "Croacia",
        },
        {
          rank: 48,
          name: "Philippe Barbarin",
          wiki: "https://en.wikipedia.org/wiki/Philippe_Barbarin",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Philippe_Barbarin_%28cropped%29.jpg/500px-Philippe_Barbarin_%28cropped%29.jpg",
          country: "France",
          continent: "Europa",
          pais: "Francia",
        },
        {
          rank: 49,
          name: "P\u00E9ter Erd\u0151",
          wiki: "https://en.wikipedia.org/wiki/P%C3%A9ter_Erd%C5%91",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/P%C3%A9ter_Erd%C5%91_in_2011.jpg/500px-P%C3%A9ter_Erd%C5%91_in_2011.jpg",
          country: "Hungary",
          continent: "Europa",
          pais: "Hungr\u00EDa",
        },
        {
          rank: 60,
          name: "Stanis\u0142aw Ry\u0142ko",
          wiki: "https://en.wikipedia.org/wiki/Stanis%C5%82aw_Ry%C5%82ko",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Stanis%C5%82aw_Ry%C5%82ko_%282018%29.jpg/500px-Stanis%C5%82aw_Ry%C5%82ko_%282018%29.jpg",
          country: "Poland",
          continent: "Europa",
          pais: "Polonia",
        },
        {
          rank: 68,
          name: "Francisco Robles Ortega",
          wiki: "https://en.wikipedia.org/wiki/Francisco_Robles_Ortega",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/8/8c/D._Francisco_Robles_Ortega_%28cropped%29.jpg",
          country: "Mexico",
          continent: "Am\u00E9rica del Norte",
          pais: "M\u00E9xico",
        },
        {
          rank: 69,
          name: "Daniel DiNardo",
          wiki: "https://en.wikipedia.org/wiki/Daniel_DiNardo",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/9/9a/Daniel_DiNardo_%28142360355%29.jpg",
          country: "United States",
          continent: "Am\u00E9rica del Norte",
          pais: "Estados Unidos",
        },
        {
          rank: 70,
          name: "Odilo Scherer",
          wiki: "https://en.wikipedia.org/wiki/Odilo_Scherer",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Odilo_Scherer_em_setembro_de_2018_%28cropped%29.jpg/500px-Odilo_Scherer_em_setembro_de_2018_%28cropped%29.jpg",
          country: "Brazil",
          continent: "Am\u00E9rica del Sur",
          pais: "Brasil",
        },
        {
          rank: 73,
          name: "Robert Sarah",
          wiki: "https://en.wikipedia.org/wiki/Robert_Sarah",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Cardinal_Robert_Sarah_%28cropped%29.JPG/500px-Cardinal_Robert_Sarah_%28cropped%29.JPG",
          country: "Guinea",
          continent: "\u00C1frica",
          pais: "Guinea",
        },
        {
          rank: 75,
          name: "Raymond Leo Burke",
          wiki: "https://en.wikipedia.org/wiki/Raymond_Leo_Burke",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Burke-BB-768x1152.jpg/500px-Burke-BB-768x1152.jpg",
          country: "United States",
          continent: "Am\u00E9rica del Norte",
          pais: "Estados Unidos",
        },
        {
          rank: 76,
          name: "Kurt Koch",
          wiki: "https://en.wikipedia.org/wiki/Kurt_Koch",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Kurt_Koch_par_Claude_Truong-Ngoc_d%C3%A9cembre_2016.jpg/500px-Kurt_Koch_par_Claude_Truong-Ngoc_d%C3%A9cembre_2016.jpg",
          country: "Switzerland",
          continent: "Europa",
          pais: "Suiza",
        },
        {
          rank: 82,
          name: "Kazimierz Nycz",
          wiki: "https://en.wikipedia.org/wiki/Kazimierz_Nycz",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/K._nycz1_%28cropped%29.jpg/500px-K._nycz1_%28cropped%29.jpg",
          country: "Poland",
          continent: "Europa",
          pais: "Polonia",
        },
        {
          rank: 83,
          name: "Malcolm Ranjith",
          wiki: "https://en.wikipedia.org/wiki/Malcolm_Ranjith",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/0/0f/Cardinal_Ranjith.jpg",
          country: "Sri Lanka",
          continent: "Asia",
          pais: "Sri Lanka",
        },
        {
          rank: 84,
          name: "Reinhard Marx",
          wiki: "https://en.wikipedia.org/wiki/Reinhard_Marx",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Marx_05-2009.jpg/500px-Marx_05-2009.jpg",
          country: "Germany",
          continent: "Europa",
          pais: "Alemania",
        },
        {
          rank: 91,
          name: "Jo\u00E0o Braz de Aviz",
          wiki: "https://en.wikipedia.org/wiki/Jo%C3%A3o_Braz_de_Aviz",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/Joao_braz_de_aviz.jpg/500px-Joao_braz_de_aviz.jpg",
          country: "Brazil",
          continent: "Am\u00E9rica del Sur",
          pais: "Brasil",
        },
        {
          rank: 96,
          name: "Thomas Collins",
          wiki: "https://en.wikipedia.org/wiki/Thomas_Collins_(cardinal)",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Thomas_Christopher_Collins_2014.jpg/500px-Thomas_Christopher_Collins_2014.jpg",
          country: "Canada",
          continent: "Am\u00E9rica del Norte",
          pais: "Canad\u00E1",
        },
        {
          rank: 98,
          name: "Wim Eijk",
          wiki: "https://en.wikipedia.org/wiki/Wim_Eijk",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Willem_Eijk_%282020%29.jpg/500px-Willem_Eijk_%282020%29.jpg",
          country: "Netherlands",
          continent: "Europa",
          pais: "Pa\u00EDses Bajos",
        },
        {
          rank: 99,
          name: "Giuseppe Betori",
          wiki: "https://en.wikipedia.org/wiki/Giuseppe_Betori",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Betori.JPG/500px-Betori.JPG",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 100,
          name: "Timothy M. Dolan",
          wiki: "https://en.wikipedia.org/wiki/Timothy_M._Dolan",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/%C4%90%E1%BB%A9c_H%E1%BB%93ng_Y_Gioan_Baotixita_Ph%E1%BA%A1m_Minh_M%E1%BA%ABn.jpg/500px-%C4%90%E1%BB%A9c_H%E1%BB%93ng_Y_Gioan_Baotixita_Ph%E1%BA%A1m_Minh_M%E1%BA%ABn.jpg",
          country: "United States",
          continent: "Am\u00E9rica del Norte",
          pais: "Estados Unidos",
        },
        {
          rank: 101,
          name: "Rainer Woelki",
          wiki: "https://en.wikipedia.org/wiki/Rainer_Woelki",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Rainer_Maria_Kardinal_Woelki%2C_Erzbischof_von_K%C3%B6ln_%282019%29.jpg/500px-Rainer_Maria_Kardinal_Woelki%2C_Erzbischof_von_K%C3%B6ln_%282019%29.jpg",
          country: "Germany",
          continent: "Europa",
          pais: "Alemania",
        },
        {
          rank: 104,
          name: "James Michael Harvey",
          wiki: "https://en.wikipedia.org/wiki/James_Michael_Harvey",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/James_Cardinal_Harvey_%28cropped%29.JPG/500px-James_Cardinal_Harvey_%28cropped%29.JPG",
          country: "United States",
          continent: "Am\u00E9rica del Norte",
          pais: "Estados Unidos",
        },
        {
          rank: 105,
          name: "Baselios Cleemis",
          wiki: "https://en.wikipedia.org/wiki/Baselios_Cleemis",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Cardinal_Baselios_Cleemis_Cardinal_Thottunkal.jpg/500px-Cardinal_Baselios_Cleemis_Cardinal_Thottunkal.jpg",
          country: "India",
          continent: "Asia",
          pais: "India",
        },
        {
          rank: 109,
          name: "Gerhard Ludwig M\u00FCller",
          wiki: "https://en.wikipedia.org/wiki/Gerhard_Ludwig_M%C3%BCller",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Bischof-GL-M%C3%BCller.JPG/500px-Bischof-GL-M%C3%BCller.JPG",
          country: "Germany",
          continent: "Europa",
          pais: "Alemania",
        },
        {
          rank: 110,
          name: "Vincent Nichols",
          wiki: "https://en.wikipedia.org/wiki/Vincent_Nichols",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/1/15/Archbishop_Vincent_Nichols_%287999797353%29_%28cropped%29.jpg/500px-Archbishop_Vincent_Nichols_%287999797353%29_%28cropped%29.jpg",
          country: "United Kingdom",
          continent: "Europa",
          pais: "Reino Unido",
        },
        {
          rank: 111,
          name: "Leopoldo Brenes",
          wiki: "https://en.wikipedia.org/wiki/Leopoldo_Brenes",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Leopoldo_Jos%C3%A9_Cardinal_Brenes_Sol%C3%B3rzano_%28cropped%29.JPG/500px-Leopoldo_Jos%C3%A9_Cardinal_Brenes_Sol%C3%B3rzano_%28cropped%29.JPG",
          country: "Nicaragua",
          continent: "Am\u00E9rica Central",
          pais: "Nicaragua",
        },
        {
          rank: 112,
          name: "G\u00E9rald Lacroix",
          wiki: "https://en.wikipedia.org/wiki/G%C3%A9rald_Lacroix",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/Mouvaux_-_Cardinal_G%C3%A9rald_Cyprien_Lacroix_-_1_%28cropped%29.jpg/500px-Mouvaux_-_Cardinal_G%C3%A9rald_Cyprien_Lacroix_-_1_%28cropped%29.jpg",
          country: "Canada",
          continent: "Am\u00E9rica del Norte",
          pais: "Canad\u00E1",
        },
        {
          rank: 113,
          name: "Jean-Pierre Kutwa",
          wiki: "https://en.wikipedia.org/wiki/Jean-Pierre_Kutwa",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/0/02/Jean_Pierre_Kutwa.jpg",
          country: "Ivory Coast",
          continent: "\u00C1frica",
          pais: "Costa de Marfil",
        },
        {
          rank: 114,
          name: "Orani Jo\u00E0o Tempesta",
          wiki: "https://en.wikipedia.org/wiki/Orani_Jo%C3%A3o_Tempesta",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Formatura_das_primeiras_mulheres_fuzileiros_navais_-_2024_%2853838900768%29-edit.jpg/500px-Formatura_das_primeiras_mulheres_fuzileiros_navais_-_2024_%2853838900768%29-edit.jpg",
          country: "Brazil",
          continent: "Am\u00E9rica del Sur",
          pais: "Brasil",
        },
        {
          rank: 116,
          name: "Mario Aurelio Poli",
          wiki: "https://en.wikipedia.org/wiki/Mario_Aurelio_Poli",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Mario_Aurelio_Cardinal_Poli_%28cropped%29.JPG/500px-Mario_Aurelio_Cardinal_Poli_%28cropped%29.JPG",
          country: "Argentina",
          continent: "Am\u00E9rica del Sur",
          pais: "Argentina",
        },
        {
          rank: 119,
          name: "Philippe Ou\u00E9draogo",
          wiki: "https://en.wikipedia.org/wiki/Philippe_Ou%C3%A9draogo_(cardinal)",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/5/56/Philippe_Ou%C3%A9draogo.jpg",
          country: "Burkina Faso",
          continent: "\u00C1frica",
          pais: "Burkina Faso",
        },
        {
          rank: 121,
          name: "Chibly Langlois",
          wiki: "https://en.wikipedia.org/wiki/Chibly_Langlois",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/President_Ma_and_Chibly_Langlois_%2817262956123%29_%28cropped%29.jpg/500px-President_Ma_and_Chibly_Langlois_%2817262956123%29_%28cropped%29.jpg",
          country: "Haiti",
          continent: "Am\u00E9rica del Norte",
          pais: "Hait\u00ED",
        },
        {
          rank: 122,
          name: "Manuel Clemente",
          wiki: "https://en.wikipedia.org/wiki/Manuel_Clemente",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Manuel_Clemente.png/500px-Manuel_Clemente.png",
          country: "Portugal",
          continent: "Europa",
          pais: "Portugal",
        },
        {
          rank: 123,
          name: "Berhaneyesus Demerew Souraphiel",
          wiki: "https://en.wikipedia.org/wiki/Berhaneyesus_Demerew_Souraphiel",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/Archbishop_Berhaneyesus_Demerew_Souraphiel.jpg/500px-Archbishop_Berhaneyesus_Demerew_Souraphiel.jpg",
          country: "Ethiopia",
          continent: "\u00C1frica",
          pais: "Etiop\u00EDa",
        },
        {
          rank: 124,
          name: "John Dew",
          wiki: "https://en.wikipedia.org/wiki/John_Dew_(cardinal)",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/John_Atcherley_Dew_in_2014.jpg/500px-John_Atcherley_Dew_in_2014.jpg",
          country: "New Zealand",
          continent: "Ocean\u00EDa",
          pais: "Nueva Zelanda",
        },
        {
          rank: 128,
          name: "Charles Maung Bo",
          wiki: "https://en.wikipedia.org/wiki/Charles_Maung_Bo",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/c/cd/Maung_Bo.jpg",
          country: "Myanmar",
          continent: "Asia",
          pais: "Birmania",
        },
        {
          rank: 129,
          name: "Kriengsak Kovitvanit",
          wiki: "https://en.wikipedia.org/wiki/Kriengsak_Kovitvanit",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Card.FX.Kriengsak.jpg/500px-Card.FX.Kriengsak.jpg",
          country: "Thailand",
          continent: "Asia",
          pais: "Tailandia",
        },
        {
          rank: 130,
          name: "Francesco Montenegro",
          wiki: "https://en.wikipedia.org/wiki/Francesco_Montenegro",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Francesco_Montenegro_concistoro.jpg/500px-Francesco_Montenegro_concistoro.jpg",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 131,
          name: "Daniel Sturla",
          wiki: "https://en.wikipedia.org/wiki/Daniel_Sturla",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Daniel_Sturla_en_Misa_0013.jpg/500px-Daniel_Sturla_en_Misa_0013.jpg",
          country: "Uruguay",
          continent: "Am\u00E9rica del Sur",
          pais: "Uruguay",
        },
        {
          rank: 134,
          name: "Arlindo Gomes Furtado",
          wiki: "https://en.wikipedia.org/wiki/Arlindo_Gomes_Furtado",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/b/b2/Arlindo_Gomes_Furtado.jpg",
          country: "Cape Verde",
          continent: "\u00C1frica",
          pais: "Cabo Verde",
        },
        {
          rank: 135,
          name: "Soane Patita Paini Mafi",
          wiki: "https://en.wikipedia.org/wiki/Soane_Patita_Paini_Mafi",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Soane_Patita_Paini_Mafi.jpg/500px-Soane_Patita_Paini_Mafi.jpg",
          country: "Tonga",
          continent: "Ocean\u00EDa",
          pais: "Tonga",
        },
        {
          rank: 138,
          name: "Dieudonn\u00E9 Nzapalainga",
          wiki: "https://en.wikipedia.org/wiki/Dieudonn%C3%A9_Nzapalainga",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/9/99/Dieudonn%C3%A9_Nzapala%C3%AFnga_VOA_cropped.jpg",
          country: "Central African Republic",
          continent: "\u00C1frica",
          pais: "Rep\u00FAblica Centroafricana",
        },
        {
          rank: 139,
          name: "Carlos Osoro Sierra",
          wiki: "https://en.wikipedia.org/wiki/Carlos_Osoro_Sierra",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Mons._Osoro_%2830877902606%29.jpg/500px-Mons._Osoro_%2830877902606%29.jpg",
          country: "Spain",
          continent: "Europa",
          pais: "Espa\u00F1a",
        },
        {
          rank: 140,
          name: "S\u00E9rgio da Rocha",
          wiki: "https://en.wikipedia.org/wiki/S%C3%A9rgio_da_Rocha",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/S%C3%A9rgio_da_Rocha.jpg/500px-S%C3%A9rgio_da_Rocha.jpg",
          country: "Brazil",
          continent: "Am\u00E9rica del Sur",
          pais: "Brasil",
        },
        {
          rank: 141,
          name: "Blase J. Cupich",
          wiki: "https://en.wikipedia.org/wiki/Blase_J._Cupich",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Cdl._Cupich_%28cropped%29.png/500px-Cdl._Cupich_%28cropped%29.png",
          country: "United States",
          continent: "Am\u00E9rica del Norte",
          pais: "Estados Unidos",
        },
        {
          rank: 144,
          name: "Jozef De Kesel",
          wiki: "https://en.wikipedia.org/wiki/Jozef_De_Kesel",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/Monseigneur_De_Kesel_%C3%A0_la_basilique_Saint-Martin_de_Li%C3%A8ge.jpg/500px-Monseigneur_De_Kesel_%C3%A0_la_basilique_Saint-Martin_de_Li%C3%A8ge.jpg",
          country: "Belgium",
          continent: "Europa",
          pais: "B\u00E9lgica",
        },
        {
          rank: 146,
          name: "Carlos Aguiar Retes",
          wiki: "https://en.wikipedia.org/wiki/Carlos_Aguiar_Retes",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Cardenalaguiar.jpg/500px-Cardenalaguiar.jpg",
          country: "Mexico",
          continent: "Am\u00E9rica del Norte",
          pais: "M\u00E9xico",
        },
        {
          rank: 147,
          name: "John Ribat",
          wiki: "https://en.wikipedia.org/wiki/John_Ribat",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/John_Ribat_%28cropped%29.jpg/500px-John_Ribat_%28cropped%29.jpg",
          country: "Papua New Guinea",
          continent: "Ocean\u00EDa",
          pais: "Pap\u00FAa Nueva Guinea",
        },
        {
          rank: 148,
          name: "Joseph W. Tobin",
          wiki: "https://en.wikipedia.org/wiki/Joseph_W._Tobin",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Cardinal_Tobin_%28cropped%29.jpg/500px-Cardinal_Tobin_%28cropped%29.jpg",
          country: "United States",
          continent: "Am\u00E9rica del Norte",
          pais: "Estados Unidos",
        },
        {
          rank: 150,
          name: "Juan Jos\u00E9 Omella",
          wiki: "https://en.wikipedia.org/wiki/Juan_Jos%C3%A9_Omella",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Card._Omella_%2834385666133%29.jpg/500px-Card._Omella_%2834385666133%29.jpg",
          country: "Spain",
          continent: "Europa",
          pais: "Espa\u00F1a",
        },
        {
          rank: 151,
          name: "Anders Arborelius",
          wiki: "https://en.wikipedia.org/wiki/Anders_Arborelius",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Anders_Arborelius_in_2019.jpg/500px-Anders_Arborelius_in_2019.jpg",
          country: "Sweden",
          continent: "Europa",
          pais: "Suecia",
        },
        {
          rank: 154,
          name: "Angelo De Donatis",
          wiki: "https://en.wikipedia.org/wiki/Angelo_De_Donatis",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/AngeloDeDonatis.jpg/500px-AngeloDeDonatis.jpg",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 155,
          name: "Joseph Coutts",
          wiki: "https://en.wikipedia.org/wiki/Joseph_Coutts",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Mgr_Coutts_%C3%A0_la_Nuit_des_T%C3%A9moins_2016_%28cropped%29.jpg/500px-Mgr_Coutts_%C3%A0_la_Nuit_des_T%C3%A9moins_2016_%28cropped%29.jpg",
          country: "Pakistan",
          continent: "Asia",
          pais: "Pakist\u00E1n",
        },
        {
          rank: 156,
          name: "Ant\u00F3nio Marto",
          wiki: "https://en.wikipedia.org/wiki/Ant%C3%B3nio_Marto",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/Ant%C3%B3nio_Marto_%28Ordination_%C3%A9piscopale_de_Mgr_Tolentino%29.jpg/500px-Ant%C3%B3nio_Marto_%28Ordination_%C3%A9piscopale_de_Mgr_Tolentino%29.jpg",
          country: "Portugal",
          continent: "Europa",
          pais: "Portugal",
        },
        {
          rank: 158,
          name: "D\u00E9sir\u00E9 Tsarahazana",
          wiki: "https://en.wikipedia.org/wiki/D%C3%A9sir%C3%A9_Tsarahazana",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/1/1e/Mgr._D%C3%A9sir%C3%A9_Tsarahazana.jpg",
          country: "Madagascar",
          continent: "\u00C1frica",
          pais: "Madagascar",
        },
        {
          rank: 159,
          name: "Giuseppe Petrocchi",
          wiki: "https://en.wikipedia.org/wiki/Giuseppe_Petrocchi",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/Foto_Cardinale_Petrocchi_-_cropped.jpg/500px-Foto_Cardinale_Petrocchi_-_cropped.jpg",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 160,
          name: "Thomas Aquino Manyo Maeda",
          wiki: "https://en.wikipedia.org/wiki/Thomas_Aquino_Manyo_Maeda",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/f/f8/Archbishop_Thomas_Aquinas_Manyo_Maeda_in_2015.jpg",
          country: "Japan",
          continent: "Asia",
          pais: "Jap\u00F3n",
        },
        {
          rank: 162,
          name: "Ignatius Suharyo Hardjoatmodjo",
          wiki: "https://en.wikipedia.org/wiki/Ignatius_Suharyo_Hardjoatmodjo",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/%2BIgnatius_Kardinal_Suharyo_%28cropped%29.jpg/500px-%2BIgnatius_Kardinal_Suharyo_%28cropped%29.jpg",
          country: "Indonesia",
          continent: "Asia",
          pais: "Indonesia",
        },
        {
          rank: 163,
          name: "Juan Garc\u00EDa Rodr\u00EDguez",
          wiki: "https://en.wikipedia.org/wiki/Juan_Garc%C3%ADa_Rodr%C3%ADguez",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/5/5c/Juan_de_la_Caridad_Garc%C3%ADa_Rodr%C3%ADguez.jpg",
          country: "Cuba",
          continent: "Am\u00E9rica del Norte",
          pais: "Cuba",
        },
        {
          rank: 164,
          name: "Fridolin Ambongo Besungu",
          wiki: "https://en.wikipedia.org/wiki/Fridolin_Ambongo_Besungu",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/AED_11%C3%A8me_Nuit_des_T%C3%A9moins_-_Fridolin_Ambongo_-_2_%28cropped%29.jpg/500px-AED_11%C3%A8me_Nuit_des_T%C3%A9moins_-_Fridolin_Ambongo_-_2_%28cropped%29.jpg",
          country: "Democratic Republic of the Congo",
          continent: "\u00C1frica",
          pais: "Rep\u00FAblica Democr\u00E1tica del Congo",
        },
        {
          rank: 165,
          name: "Jean-Claude Hollerich",
          wiki: "https://en.wikipedia.org/wiki/Jean-Claude_Hollerich",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/Jean-Claude_Hollerich.jpg/500px-Jean-Claude_Hollerich.jpg",
          country: "Luxembourg",
          continent: "Europa",
          pais: "Luxemburgo",
        },
        {
          rank: 166,
          name: "\u00C1lvaro Leonel Ramazzini Imeri",
          wiki: "https://en.wikipedia.org/wiki/%C3%81lvaro_Leonel_Ramazzini_Imeri",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Bishop_Alvaro_Ramazzini_%286165910686%29_%28cropped%29.jpg/500px-Bishop_Alvaro_Ramazzini_%286165910686%29_%28cropped%29.jpg",
          country: "Guatemala",
          continent: "Am\u00E9rica Central",
          pais: "Guatemala",
        },
        {
          rank: 167,
          name: "Matteo Zuppi",
          wiki: "https://en.wikipedia.org/wiki/Matteo_Zuppi",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Matteo_Zuppi_2019.jpg/500px-Matteo_Zuppi_2019.jpg",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 168,
          name: "Crist\u00F3bal L\u00F3pez Romero",
          wiki: "https://en.wikipedia.org/wiki/Crist%C3%B3bal_L%C3%B3pez_Romero",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/5/55/Crist%C3%B3bal_L%C3%B3pez_Romero.jpg",
          country: "Morocco",
          continent: "\u00C1frica",
          pais: "Marruecos",
        },
        {
          rank: 170,
          name: "Antoine Kambanda",
          wiki: "https://en.wikipedia.org/wiki/Antoine_Kambanda",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/His_Eminence_Antoine_cardinal_Kambanda%2C_GCLJ.jpg/500px-His_Eminence_Antoine_cardinal_Kambanda%2C_GCLJ.jpg",
          country: "Rwanda",
          continent: "\u00C1frica",
          pais: "Ruanda",
        },
        {
          rank: 171,
          name: "Wilton Daniel Gregory",
          wiki: "https://en.wikipedia.org/wiki/Wilton_Daniel_Gregory",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Cardinal_Wilton_Daniel_Gregory_in_2024_%28cropped%29.jpg/500px-Cardinal_Wilton_Daniel_Gregory_in_2024_%28cropped%29.jpg",
          country: "United States",
          continent: "Am\u00E9rica del Norte",
          pais: "Estados Unidos",
        },
        {
          rank: 172,
          name: "Jose Advincula",
          wiki: "https://en.wikipedia.org/wiki/Jose_Advincula",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Portrait_of_Cardinal_Advincula.jpg/500px-Portrait_of_Cardinal_Advincula.jpg",
          country: "Philippines",
          continent: "Asia",
          pais: "Filipinas",
        },
        {
          rank: 174,
          name: "Augusto Paolo Lojudice",
          wiki: "https://en.wikipedia.org/wiki/Augusto_Paolo_Lojudice",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Augusto_Paolo_Lojudice_con_il_pallio.jpg/500px-Augusto_Paolo_Lojudice_con_il_pallio.jpg",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 176,
          name: "Jean-Marc Aveline",
          wiki: "https://en.wikipedia.org/wiki/Jean-Marc_Aveline",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Mgr_Jean-Marc_Aveline_par_Claude_Truong-Ngoc_juillet_2021.jpg/500px-Mgr_Jean-Marc_Aveline_par_Claude_Truong-Ngoc_juillet_2021.jpg",
          country: "France",
          continent: "Europa",
          pais: "Francia",
        },
        {
          rank: 177,
          name: "Peter Okpaleke",
          wiki: "https://en.wikipedia.org/wiki/Peter_Okpaleke",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/5/55/Peter_Okpaleke.jpg",
          country: "Nigeria",
          continent: "\u00C1frica",
          pais: "Nigeria",
        },
        {
          rank: 178,
          name: "Leonardo Ulrich Steiner",
          wiki: "https://en.wikipedia.org/wiki/Leonardo_Ulrich_Steiner",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Leonardo_Steiner.jpg/500px-Leonardo_Steiner.jpg",
          country: "Brazil",
          continent: "Am\u00E9rica del Sur",
          pais: "Brasil",
        },
        {
          rank: 179,
          name: "Filipe Neri Ferr\u00E0o",
          wiki: "https://en.wikipedia.org/wiki/Filipe_Neri_Ferr%C3%A3o",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/a/a5/Filipe_Neri_Ferrao_%28cropped%29.jpg",
          country: "India",
          continent: "Asia",
          pais: "India",
        },
        {
          rank: 180,
          name: "Robert W. McElroy",
          wiki: "https://en.wikipedia.org/wiki/Robert_W._McElroy",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/BishopMcelroyUGCC_%28cropped%29.jpg/500px-BishopMcelroyUGCC_%28cropped%29.jpg",
          country: "United States",
          continent: "Am\u00E9rica del Norte",
          pais: "Estados Unidos",
        },
        {
          rank: 181,
          name: "Virg\u00EDlio do Carmo da Silva",
          wiki: "https://en.wikipedia.org/wiki/Virg%C3%ADlio_do_Carmo_da_Silva",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/3/38/2017-03-30_Virg%C3%ADlio_do_Carmo_da_Silva.jpg",
          country: "East Timor",
          continent: "Asia",
          pais: "Timor Oriental",
        },
        {
          rank: 182,
          name: "Oscar Cantoni",
          wiki: "https://en.wikipedia.org/wiki/Oscar_Cantoni",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Card._Cantoni_27-08-22.jpg/500px-Card._Cantoni_27-08-22.jpg",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 183,
          name: "Anthony Poola",
          wiki: "https://en.wikipedia.org/wiki/Anthony_Poola",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Poola_Anthony.jpg/500px-Poola_Anthony.jpg",
          country: "India",
          continent: "Asia",
          pais: "India",
        },
        {
          rank: 184,
          name: "Paulo Cezar Costa",
          wiki: "https://en.wikipedia.org/wiki/Paulo_Cezar_Costa",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Cardeal_Costa.jpg/500px-Cardeal_Costa.jpg",
          country: "Brazil",
          continent: "Am\u00E9rica del Sur",
          pais: "Brasil",
        },
        {
          rank: 185,
          name: "William Goh",
          wiki: "https://en.wikipedia.org/wiki/William_Goh",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Cardinal_William_Goh_%28cropped%29.jpg/500px-Cardinal_William_Goh_%28cropped%29.jpg",
          country: "Singapore",
          continent: "Asia",
          pais: "Singapur",
        },
        {
          rank: 186,
          name: "Adalberto Mart\u00EDnez Flores",
          wiki: "https://en.wikipedia.org/wiki/Adalberto_Mart%C3%ADnez_Flores",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Adalberto_Mart%C3%ADnez_Flores.jpg/500px-Adalberto_Mart%C3%ADnez_Flores.jpg",
          country: "Paraguay",
          continent: "Am\u00E9rica del Sur",
          pais: "Paraguay",
        },
        {
          rank: 187,
          name: "Giorgio Marengo",
          wiki: "https://en.wikipedia.org/wiki/Giorgio_Marengo",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/1/10/Cardeal_marengo.jpg",
          country: "Mongolia",
          continent: "Asia",
          pais: "Mongolia",
        },
        {
          rank: 190,
          name: "Pierbattista Pizzaballa",
          wiki: "https://en.wikipedia.org/wiki/Pierbattista_Pizzaballa",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/b/bf/Mons._Pierbattista_Pizzaballa.jpg",
          country: "Jerusalem",
          continent: "Asia",
          pais: "Jerusal\u00E9n",
        },
        {
          rank: 191,
          name: "Stephen Brislin",
          wiki: "https://en.wikipedia.org/wiki/Stephen_Brislin",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/9/96/Stephen_Brislin.jpg",
          country: "South Africa",
          continent: "\u00C1frica",
          pais: "Sud\u00E1frica",
        },
        {
          rank: 192,
          name: "\u00C1ngel Sixto Rossi",
          wiki: "https://en.wikipedia.org/wiki/%C3%81ngel_Sixto_Rossi",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Angel_Rossi_Arzobispo_1.1.jpg/500px-Angel_Rossi_Arzobispo_1.1.jpg",
          country: "Argentina",
          continent: "Am\u00E9rica del Sur",
          pais: "Argentina",
        },
        {
          rank: 193,
          name: "Luis Jos\u00E9 Rueda Aparicio",
          wiki: "https://en.wikipedia.org/wiki/Luis_Jos%C3%A9_Rueda_Aparicio",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Archbishop_Luis_Jose_Rueda_Aparicio_1.jpg/500px-Archbishop_Luis_Jose_Rueda_Aparicio_1.jpg",
          country: "Colombia",
          continent: "Am\u00E9rica del Sur",
          pais: "Colombia",
        },
        {
          rank: 194,
          name: "Grzegorz Ry\u015B",
          wiki: "https://en.wikipedia.org/wiki/Grzegorz_Ry%C5%9B",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Arcybiskup_Grzegorz_Ry%C5%9B_podczas_Wigilii_Paschalnej_2020_%28cropped%29.jpg/500px-Arcybiskup_Grzegorz_Ry%C5%9B_podczas_Wigilii_Paschalnej_2020_%28cropped%29.jpg",
          country: "Poland",
          continent: "Europa",
          pais: "Polonia",
        },
        {
          rank: 195,
          name: "Stephen Ameyu Martin Mulla",
          wiki: "https://en.wikipedia.org/wiki/Stephen_Ameyu_Martin_Mulla",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/d/df/Ameyu_Martin_Mulla_%28edit%29.jpg",
          country: "South Sudan",
          continent: "\u00C1frica",
          pais: "Sud\u00E1n del Sur",
        },
        {
          rank: 196,
          name: "Jos\u00E9 Cobo Cano",
          wiki: "https://en.wikipedia.org/wiki/Jos%C3%A9_Cobo_Cano",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Toma_posesi%C3%B3n_de_Jos%C3%A9_Cobo_de_Santa_Mar%C3%ADa_de_Montserrat%2C_Roma_04.jpg/500px-Toma_posesi%C3%B3n_de_Jos%C3%A9_Cobo_de_Santa_Mar%C3%ADa_de_Montserrat%2C_Roma_04.jpg",
          country: "Spain",
          continent: "Europa",
          pais: "Espa\u00F1a",
        },
        {
          rank: 197,
          name: "Protase Rugambwa",
          wiki: "https://en.wikipedia.org/wiki/Protase_Rugambwa",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/f/f5/Rugambwa_Protase.jpg",
          country: "Tanzania",
          continent: "\u00C1frica",
          pais: "Tanzania",
        },
        {
          rank: 198,
          name: "Sebastian Francis",
          wiki: "https://en.wikipedia.org/wiki/Sebastian_Francis",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/a/ab/Sebastian_Francis.jpg",
          country: "Malaysia",
          continent: "Asia",
          pais: "Malasia",
        },
        {
          rank: 199,
          name: "Stephen Chow Sau-yan",
          wiki: "https://en.wikipedia.org/wiki/Stephen_Chow_(bishop)",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/202309_CardinalStephenCHOW_1H_ForMedia.jpg/500px-202309_CardinalStephenCHOW_1H_ForMedia.jpg",
          country: "China",
          continent: "Asia",
          pais: "China",
        },
        {
          rank: 200,
          name: "Fran\u00E7ois-Xavier Bustillo",
          wiki: "https://en.wikipedia.org/wiki/Fran%C3%A7ois-Xavier_Bustillo",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/c/c5/Fran%C3%A7ois-Xavier_Bustillo_%28cropped%29.jpg",
          country: "France",
          continent: "Europa",
          pais: "Francia",
        },
        {
          rank: 201,
          name: "Am\u00E9rico Aguiar",
          wiki: "https://en.wikipedia.org/wiki/Am%C3%A9rico_Aguiar",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/6/60/Mons._Americo_Aguiar_visita_a_los_j%C3%B3venes_de_Tierra_Santa%2C_2023.png",
          country: "Portugal",
          continent: "Europa",
          pais: "Portugal",
        },
        {
          rank: 203,
          name: "Carlos Castillo Mattasoglio",
          wiki: "https://en.wikipedia.org/wiki/Carlos_Castillo_Mattasoglio",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Carlos_Castillo_Mattasoglio_%28edit%29.jpg/500px-Carlos_Castillo_Mattasoglio_%28edit%29.jpg",
          country: "Peru",
          continent: "Am\u00E9rica del Sur",
          pais: "Per\u00FA",
        },
        {
          rank: 204,
          name: "Vicente Bokalic Iglic",
          wiki: "https://en.wikipedia.org/wiki/Vicente_Bokalic_Iglic",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Cardenal_Bokalic.png/375px-Cardenal_Bokalic.png",
          country: "Argentina",
          continent: "Am\u00E9rica del Sur",
          pais: "Argentina",
        },
        {
          rank: 205,
          name: "Luis Cabrera Herrera",
          wiki: "https://en.wikipedia.org/wiki/Luis_Cabrera_Herrera",
          image_url:
            "https://www.conferenciaepiscopal.ec/templates/yootheme/cache/1f/CARD3-1fe7dd2c.jpeg",
          country: "Ecuador",
          continent: "Am\u00E9rica del Sur",
          pais: "Ecuador",
        },
        {
          rank: 206,
          name: "Fernando Chomal\u00ED Garib",
          wiki: "https://en.wikipedia.org/wiki/Fernando_Chomal%C3%AD_Garib",
          image_url:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT38KKmVSSN4KjDL_nLVaczrrM5AsWisgCnGA&s",
          country: "Chile",
          continent: "Am\u00E9rica del Sur",
          pais: "Chile",
        },
        {
          rank: 207,
          name: "Tarcisio Isao Kikuchi",
          wiki: "https://en.wikipedia.org/wiki/Tarcisio_Isao_Kikuchi",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Cardinal_Tarsicio_Isao_Kikuchi.jpg/500px-Cardinal_Tarsicio_Isao_Kikuchi.jpg",
          country: "Japan",
          continent: "Asia",
          pais: "Jap\u00F3n",
        },
        {
          rank: 208,
          name: "Pablo Virgilio David",
          wiki: "https://en.wikipedia.org/wiki/Pablo_Virgilio_David",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Pablo_Virgilio_David_in_2014_%28Retouched%29.jpg/500px-Pablo_Virgilio_David_in_2014_%28Retouched%29.jpg",
          country: "Philippines",
          continent: "Asia",
          pais: "Filipinas",
        },
        {
          rank: 209,
          name: "Ladislav Nemet",
          wiki: "https://en.wikipedia.org/wiki/Ladislav_Nemet",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/5/5f/Nemet_2009.jpg",
          country: "Serbia",
          continent: "Europa",
          pais: "Serbia",
        },
        {
          rank: 210,
          name: "Jaime Spengler",
          wiki: "https://en.wikipedia.org/wiki/Jaime_Spengler",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Dom_Jaime_Spengler_-_Arcebispo.JPG/500px-Dom_Jaime_Spengler_-_Arcebispo.JPG",
          country: "Brazil",
          continent: "Am\u00E9rica del Sur",
          pais: "Brasil",
        },
        {
          rank: 211,
          name: "Ignace Bessi Dogbo",
          wiki: "https://en.wikipedia.org/wiki/Ignace_Bessi_Dogbo",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Ignace_Bessi_Dogbo.png/500px-Ignace_Bessi_Dogbo.png",
          country: "Ivory Coast",
          continent: "\u00C1frica",
          pais: "Costa de Marfil",
        },
        {
          rank: 212,
          name: "Jean-Paul Vesco",
          wiki: "https://en.wikipedia.org/wiki/Jean-Paul_Vesco",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/b/b0/Jean-Paul_Vesco%2C_OP-022022.jpg",
          country: "Algeria",
          continent: "\u00C1frica",
          pais: "Argelia",
        },
        {
          rank: 213,
          name: "Dominique Mathieu",
          wiki: "https://en.wikipedia.org/wiki/Dominique_Mathieu",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/a/a8/Dominique_Mathieu_OFMConv.jpg",
          country: "Iran",
          continent: "Asia",
          pais: "Ir\u00E1n",
        },
        {
          rank: 214,
          name: "Roberto Repole",
          wiki: "https://en.wikipedia.org/wiki/Roberto_Repole",
          image_url:
            "https://collegeofcardinalsreport.com/wp-content/uploads/2024/12/Cardinal-Roberto-Repole-e1733759772672.jpeg",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 215,
          name: "Baldassare Reina",
          wiki: "https://en.wikipedia.org/wiki/Baldassare_Reina",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Baldassare_Reina.jpg/500px-Baldassare_Reina.jpg",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 216,
          name: "Frank Leo",
          wiki: "https://en.wikipedia.org/wiki/Frank_Leo",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Frank_Leo.jpg/500px-Frank_Leo.jpg",
          country: "Canada",
          continent: "Am\u00E9rica del Norte",
          pais: "Canad\u00E1",
        },
        {
          rank: 217,
          name: "Mykola Bychok",
          wiki: "https://en.wikipedia.org/wiki/Mykola_Bychok",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Mykola_Bychok%2C_CSsR.jpg/500px-Mykola_Bychok%2C_CSsR.jpg",
          country: "Australia",
          continent: "Ocean\u00EDa",
          pais: "Australia",
        },
        {
          rank: 218,
          name: "Domenico Battaglia",
          wiki: "https://en.wikipedia.org/wiki/Domenico_Battaglia_(bishop)",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Don_Mimmo_Battaglia_pentecoste_2018_%28cropped%29.jpg/500px-Don_Mimmo_Battaglia_pentecoste_2018_%28cropped%29.jpg",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 219,
          name: "Dominique Mamberti",
          wiki: "https://en.wikipedia.org/wiki/Dominique_Mamberti",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Dominique_Mamberti%2C_14_Dec_2010.jpg/500px-Dominique_Mamberti%2C_14_Dec_2010.jpg",
          country: "France",
          continent: "Europa",
          pais: "Francia",
        },
        {
          rank: 220,
          name: "Mario Zenari",
          wiki: "https://en.wikipedia.org/wiki/Mario_Zenari",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Mario_Zenari.jpg/500px-Mario_Zenari.jpg",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 221,
          name: "Kevin Farrell",
          wiki: "https://en.wikipedia.org/wiki/Kevin_Farrell",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Kevin_Joseph_Farrell_1.jpg/500px-Kevin_Joseph_Farrell_1.jpg",
          country: "United States",
          continent: "Am\u00E9rica del Norte",
          pais: "Estados Unidos",
        },
        {
          rank: 225,
          name: "Konrad Krajewski",
          wiki: "https://en.wikipedia.org/wiki/Konrad_Krajewski",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Konrad_Krajewski_%282020%29.jpg/500px-Konrad_Krajewski_%282020%29.jpg",
          country: "Poland",
          continent: "Europa",
          pais: "Polonia",
        },
        {
          rank: 227,
          name: "Jos\u00E9 Tolentino de Mendon\u00E7a",
          wiki: "https://en.wikipedia.org/wiki/Jos%C3%A9_Tolentino_de_Mendon%C3%A7a",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Cardeal_De_Mendon%C3%A7a.jpg/500px-Cardeal_De_Mendon%C3%A7a.jpg",
          country: "Portugal",
          continent: "Europa",
          pais: "Portugal",
        },
        {
          rank: 228,
          name: "Michael Czerny",
          wiki: "https://en.wikipedia.org/wiki/Michael_Czerny",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/b/b2/Card._Michael_Czerny_S.J._at_the_Vatican.jpg",
          country: "Canada",
          continent: "Am\u00E9rica del Norte",
          pais: "Canad\u00E1",
        },
        {
          rank: 230,
          name: "Mario Grech",
          wiki: "https://en.wikipedia.org/wiki/Mario_Grech",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Cardinal_Mario_Grech_%28cropped%29.jpg/500px-Cardinal_Mario_Grech_%28cropped%29.jpg",
          country: "Malta",
          continent: "Europa",
          pais: "Malta",
        },
        {
          rank: 231,
          name: "Marcello Semeraro",
          wiki: "https://en.wikipedia.org/wiki/Marcello_Semeraro",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/5/5a/Semeraro_Udienza_20170504.jpg",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 232,
          name: "Mauro Gambetti",
          wiki: "https://en.wikipedia.org/wiki/Mauro_Gambetti",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/1/1a/Cardinale_Mauro_Gambetti.png",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 236,
          name: "Arthur Roche",
          wiki: "https://en.wikipedia.org/wiki/Arthur_Roche",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/e/ec/Bishop_Arthur_Roche_2008.jpg",
          country: "United Kingdom",
          continent: "Europa",
          pais: "Reino Unido",
        },
        {
          rank: 237,
          name: "Lazarus You Heung-sik",
          wiki: "https://en.wikipedia.org/wiki/Lazarus_You_Heung-sik",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Card._Heung-sik.png/500px-Card._Heung-sik.png",
          country: "South Korea",
          continent: "Asia",
          pais: "Corea del Sur",
        },
        {
          rank: 241,
          name: "Claudio Gugerotti",
          wiki: "https://en.wikipedia.org/wiki/Claudio_Gugerotti",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Claudio_Gugerotti_1.jpg/500px-Claudio_Gugerotti_1.jpg",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 242,
          name: "V\u00EDctor Manuel Fern\u00E1ndez",
          wiki: "https://en.wikipedia.org/wiki/V%C3%ADctor_Manuel_Fern%C3%A1ndez",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/V%C3%ADctor_Manuel_Fern%C3%A1ndez-%28cropped%29.jpg/500px-V%C3%ADctor_Manuel_Fern%C3%A1ndez-%28cropped%29.jpg",
          country: "Argentina",
          continent: "Am\u00E9rica del Sur",
          pais: "Argentina",
        },
        {
          rank: 243,
          name: "Emil Paul Tscherrig",
          wiki: "https://en.wikipedia.org/wiki/Emil_Paul_Tscherrig",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/Emil_Paul_Tscherrig_%28cropped%29.jpg/500px-Emil_Paul_Tscherrig_%28cropped%29.jpg",
          country: "Switzerland",
          continent: "Europa",
          pais: "Suiza",
        },
        {
          rank: 244,
          name: "Christophe Pierre",
          wiki: "https://en.wikipedia.org/wiki/Christophe_Pierre",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/ChristophePierre_%28cropped%29.jpg/500px-ChristophePierre_%28cropped%29.jpg",
          country: "France",
          continent: "Europa",
          pais: "Francia",
        },
        {
          rank: 245,
          name: "\u00C1ngel Fern\u00E1ndez Artime",
          wiki: "https://en.wikipedia.org/wiki/%C3%81ngel_Fern%C3%A1ndez_Artime",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/%C3%81ngel_Fern%C3%A1ndez_Artime.jpg/500px-%C3%81ngel_Fern%C3%A1ndez_Artime.jpg",
          country: "Spain",
          continent: "Europa",
          pais: "Espa\u00F1a",
        },
        {
          rank: 249,
          name: "Rolandas Makrickas",
          wiki: "https://en.wikipedia.org/wiki/Rolandas_Makrickas",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Rolandas_makrickas-1_%28edit%29.jpg/500px-Rolandas_makrickas-1_%28edit%29.jpg",
          country: "Lithuania",
          continent: "Europa",
          pais: "Lituania",
        },
        {
          rank: 250,
          name: "Timothy Radcliffe",
          wiki: "https://en.wikipedia.org/wiki/Timothy_Radcliffe",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/2025.02.22._Timothy_Radcliffe_OP_Warsaw_Poland_Photo_Mariusz_Kubik_01.JPG/500px-2025.02.22._Timothy_Radcliffe_OP_Warsaw_Poland_Photo_Mariusz_Kubik_01.JPG",
          country: "United Kingdom",
          continent: "Europa",
          pais: "Reino Unido",
        },
        {
          rank: 251,
          name: "Fabio Baggio",
          wiki: "https://en.wikipedia.org/wiki/Fabio_Baggio",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Fabio_Baggio-5-2-2019.jpg/500px-Fabio_Baggio-5-2-2019.jpg",
          country: "Italy",
          continent: "Europa",
          pais: "Italia",
        },
        {
          rank: 252,
          name: "George Koovakad",
          wiki: "https://en.wikipedia.org/wiki/George_Koovakad",
          image_url:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Card._George_J._Koovakad.jpg/500px-Card._George_J._Koovakad.jpg",
          country: "India",
          continent: "Asia",
          pais: "India",
        },
      ],
    };
  },
  methods: {
    autoPick() {
      let i = Math.floor(Math.random() * this.electors.length);
      this.randomItem = this.electors[i];
    },
    toogleBookmark(rank) {
      if (!rank) return;
      if (!this.bookmarks) this.bookmarks = [];

      let i = this.bookmarks.findIndex((x) => x == rank);
      console.log("indexx", i);
      if (i == -1) {
        this.bookmarks.push(rank);
      } else {
        this.bookmarks.splice(i, 1);
      }

      localStorage.setItem("bookmarks", JSON.stringify(this.bookmarks));
    },
    toggleContinent(c) {
      if (this.continent == c || c == "Unknown") {
        this.continent = null;
      } else {
        this.continent = c;
      }

      this.country = null;
    },
    toggleCountry(c) {
      if (this.country == c) {
        this.country = null;
      } else {
        this.country = c;
      }
    },
  },
  mounted() {
    this.bookmarks = JSON.parse(localStorage.getItem("bookmarks") || "[]");
  },
};
</script>

<style>
.chip {
  border-radius: 5px;
  border: 1px solid #ccc;

  padding: 4px 8px;
  margin: 2px 4px;
  cursor: pointer;
}

/* CSS */
.people-container {
  display: flex;
  flex-wrap: wrap; /* wrap cards onto new rows */
  gap: 1rem; /* space between cards */
  justify-content: center; /* center the row; use flex-start if you prefer */
}

.person-card {
  display: flex;
  flex-direction: column; /* stack image and title */

  max-width: 150px; /* fixed width per card */
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.person-card:hover {
  transform: translateY(-4px);
}

.person-card img {
  display: block; /* removes inline gaps */
  width: 100%;
  height: 180px; /* uniform image height */
  object-fit: cover;
}

.person-card h3 {
  margin: 0.5rem;
  text-align: center;
  font-size: 1rem;
  color: #333;
  flex-grow: 1; /* pushes any extra space below if you add buttons later */
}
.country {
  text-align: center;
}

.no-link {
  color: #333;
  text-decoration: none;
}

body {
  font-family: Georgia, "Times New Roman", Times, serif;
}
</style>
